export default "__VITE_ASSET__YTL$qiFL__"